import { Fragment } from "react/jsx-runtime"
import { HeaderInfobar } from "./sections/HeaderInfobar"
import { PageTitle } from "./sections/PageTitle"
import { Tab } from "./sections/Tab"
import { PAYMENT_TABS } from "./sections/Tab/payment-tabs"
import { IBANTransactionTable } from "./sections/Table"
import "./style.sass"

export const Payments = () => {
  return (
    <Fragment>
      <div className="payments">
        <PageTitle title="Payments" />
        <HeaderInfobar />
      </div>
      <Tab tabs={PAYMENT_TABS} active={PAYMENT_TABS[0]} />
      <IBANTransactionTable />
    </Fragment>
  )
}
